import {createEntityAdapter} from '@reduxjs/toolkit';

/** @namespace Blackouts.Adapters */

/**
 * CRUD adapter for handling Inventory Blackouts data within the store.  Default is sorted by the  blackout ID (spotBlackoutId).
 *
 * @see https://redux-toolkit.js.org/api/createEntityAdapter
 */
export const blackoutsAdapter = createEntityAdapter({
    selectId: (blackout) => blackout.spotBlackoutId,
});
